module.exports = __webpack_public_path__ + "sciencequest-e224bbc5707d9c967ac0495273ac0bf9.svg";